export default __webpack_public_path__ + "566f3e41acd0d7b73e8843291461a19b.png";